import Flickity from 'flickity';
import $ from 'jquery';

// @ts-ignore
import Splitting from 'splitting';

const initHeroBlock = (): void => {


    const elements = document.querySelectorAll('.phone-swiper__carousel');
    if (elements) {
        elements.forEach((element: HTMLElement) => {
            const splits = $(element).closest('.hero').find('[data-splitting]');
            Splitting({ whitespace: true, target: splits.toArray() });

            const flkty = new Flickity(element, {
                prevNextButtons: false,
                pageDots: false,
                autoPlay: 3500,
                wrapAround: true,
            })

            let cancelTimeout: NodeJS.Timeout;

            flkty.on('change', (index) => {
                try {
                    clearTimeout(cancelTimeout);
                } catch (e) {
                    console.error(e);
                }

                const splits = $(element).closest('.hero').find('[data-splitting]');
                splits.addClass('out');

                // @ts-ignore
                const cell = flkty.cells[index];
                const nextText = cell.element.getAttribute('data-text');

                cancelTimeout = setTimeout(() => {
                    $(element)
                        .closest('.hero')
                        .find('.hero__split')
                        .html(`<span data-splitting>${nextText}</span>`);

                    const splits = $(element).closest('.hero').find('[data-splitting]');
                    splits.removeClass('out');

                    Splitting({ whitespace: true, target: splits.toArray() });
                }, 300);

            })
        });



    }
}

export default initHeroBlock;